export default function AttendanceIndex() {
  return <div>Attendance Report</div>
}
